module.exports = __webpack_public_path__ + "img/pause.44d94781.svg";